import './index.scss';

export default function QRCode() {
    return (
        <div className="module m-nav m-qrcode">
            <div className="mg-content">
                <img className="img-bg" src="//s.qunarzz.com/vacation_tuan/2022/dalian/ewm.png" />
            </div>
        </div>
    );
}